import "./footer.css"
import FooterLink from "./FooterLink"
import {
    Text
  } from "@fluentui/react-components";

const LINKS = [{
    text:"Youtube Channel",
    link: "https://www.youtube.com/channel/UC93sfFCG4euSAWO6kYxheUQ"
},{
    text:"LinkedIn Profile",
    link: "https://www.linkedin.com/in/abdul-rauf-03817a166/"
},{
    text:"Twitter Profile",
    link: "https://www.twitter.com/raufie_original"
},

]
const Footer=(props)=>{

    return(<div style={{marginTop:"2.5%"}}>
        
    
    <footer >
        <div style={{marginLeft:"5%"}}>     
            <Text size={700} style={{fontFamily:props.font}}>Socials and Contact</Text>
            <ul style={{color:"white"}}> {LINKS.map(item=>{
               return <li style={{marginTop:'.75%'}}>
                <FooterLink text={item.text} link={item.link}/>
                </li>
            })}
            </ul>
            
        </div>
        <div style={{marginTop:"1.3%", marginLeft:"5%",fontFamily:props.font}}> 
            @2023 Abdul Rauf
        </div>
    </footer>
  </div>)
}
export default Footer